import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import ChartFrame from "../../ChartFrame";

const ServiceSessionTimeGraphs = ({ chart, title, height }) => {

  return (
    <>
      <ChartFrame height={height || "300px"} title={title}>
        <ResponsiveContainer>
          <LineChart
            data={chart}
            margin={{
              top: 0,
              right: 10,
              left: -10,
              bottom: 15,
            }}
            isAnimationActive={false}
          >
            <CartesianGrid stroke="#EBEBEB" vertical={false} />
            <XAxis
              dataKey="date"
              name="Day"
              axisLine={{ stroke: "var(--darkGrey)", strokeWidth: 1 }}
            />
            <YAxis axisLine={{ stroke: "var(--darkGrey)", strokeWidth: 1 }} />
            <Tooltip />
            <Legend width="100%" />
            <Line
              type="monotone"
              strokeWidth={3}
              dataKey="dailyAverage"
              name="Session Time"
              stroke={"var(--blue)"}
              dot={{ fill: "var(--blue)", r: 2 }}
              activeDot={{ r: 4 }}
              animationDuration={0}
            />
          </LineChart>
        </ResponsiveContainer>
      </ChartFrame>
    </>
  );
};

export default ServiceSessionTimeGraphs;
